
import cartMixin from '@/mixins/cartMixin.js';
import { mapState } from 'vuex';
export default {
  name: 'Checkout',
  layout: 'tunnel',
  mixins: [cartMixin],

  computed: {
    ...mapState('checkout', ['checkoutError']),
    guestUser() {
      return this.$auth.user?.Customer?.Guest;
    },

    isLogin() {
      return this.$auth.loggedIn || this.guestUser;
    },

    isGuest() {
      return this.guestUser;
    },
  },

  async created() {
    await this.cartService.fetchCart({
      onSuccess: () => {
        this.loadedCart = true;
      },
      onError: () => {
        this.loadedCart = true;
      },
    });
  },
};
